/* React-hot-toast adapter replacing the vanilla NotificationSystem.
 * Provides the same method signatures so callers need minimal changes.
 * The <Toaster> component is already mounted in App.js. */
import toast from 'react-hot-toast';

export const notify = {
  showSuccessToast(title, message) {
    toast.success(`${title}\n${message}`, { duration: 5000 });
  },

  showErrorToast(title, message) {
    toast.error(`${title}\n${message}`, { duration: 6000 });
  },

  showInfoToast(title, message) {
    toast(`${title}\n${message}`, { duration: 4000, icon: 'ℹ️' });
  },

  showWarningToast(title, message) {
    toast(`${title}\n${message}`, { duration: 6000, icon: '⚠️' });
  },

  showConnectionError() {
    toast.error('Verbinding verbroken\nControleer je internetverbinding', { duration: 6000 });
  },

  showConversationStarted() {
    // Intentionally empty — was already commented out in NotificationSystem
  },

  showVacancyCompleted() {
    toast.success('Vacaturetekst klaar!\nJe kunt de tekst nu bekijken, kopiëren of downloaden.', { duration: 6000 });
  },

  showInsufficientInfoNotification() {
    toast('Onvoldoende informatie\nZorg dat Jesse eerst een complete vacature heeft opgesteld.', {
      duration: 5000,
      icon: '💡'
    });
  },

  /**
   * Show a rich notification with action buttons.
   * Falls back to a simple toast since react-hot-toast doesn't support buttons natively.
   * For confirmation dialogs, use showNewConversationConfirmation or showClearChatConfirmation.
   */
  showNotification({ type, title, message }) {
    const method = type === 'error' ? toast.error
                 : type === 'success' ? toast.success
                 : toast;
    method(`${title}\n${message}`, { duration: 5000 });
  },

  /**
   * Show a confirmation dialog for starting a new conversation.
   * Uses a custom toast with confirm/cancel pattern.
   */
  showNewConversationConfirmation(onConfirm, onCancel) {
    toast((t) => {
      // We can't use JSX here (this is a .js file), but react-hot-toast
      // accepts a render function that returns a string or React element.
      // For now, we'll use window.confirm as a pragmatic fallback.
      return 'Nieuw gesprek starten? Je huidige gesprek gaat verloren.';
    }, { duration: Infinity });

    // Pragmatic: use native confirm for destructive actions
    if (window.confirm('Nieuw gesprek starten? Je huidige gesprek gaat verloren.')) {
      toast.dismiss();
      onConfirm?.();
    } else {
      toast.dismiss();
      onCancel?.();
    }
  },

  showClearChatConfirmation(onConfirm) {
    if (window.confirm('Chat wissen? Alle berichten worden verwijderd.')) {
      onConfirm?.();
    }
  }
};
